export const GET_PAYMENT_STATUS_SUCCESS = 'GET_PAYMENT_STATUS_SUCCESS';
export const GET_PAYMENT_STATUS = 'GET_PAYMENT_STATUS';

export const GET_AVAILABLE_BANKS_SUCCESS = 'GET_AVAILABLE_BANKS_SUCCESS';
export const GET_AVAILABLE_BANKS = 'GET_AVAILABLE_BANKS';

export const UPDATE_PAYMENT_TYPE_SUCCESS = 'UPDATE_PAYMENT_TYPE_SUCCESS';
export const UPDATE_PAYMENT_TYPE = 'UPDATE_PAYMENT_TYPE';

export const CREATE_LUMPSUM_PAYMENT_SUCCESS = 'CREATE_LUMPSUM_PAYMENT_SUCCESS';
export const CREATE_LUMPSUM_PAYMENT = 'CREATE_LUMPSUM_PAYMENT';
